<script>
    import { createEventDispatcher } from "svelte";

    export let isPressed = false;
    export let isEnabled = true;
    export let action = new Function();

    const dispatch = createEventDispatcher();

    function didPress() {
        dispatch("press");
    }

    function didRelease() {
        dispatch("release");
    }
</script>

<button
    class:pressed={isPressed}
    class:enabled={isEnabled}
    on:click={action}
    on:mousedown={didPress}
    on:mouseup={didRelease}
>
    <slot />
</button>

<style>
    button {
        appearance: none;
        margin: 0;
        border-top: var(--border-color-light) var(--chrome-depth) outset;
        border-right: var(--border-color-dark) var(--chrome-depth) outset;
        border-bottom: var(--border-color-dark) var(--chrome-depth) outset;
        border-left: var(--border-color-light) var(--chrome-depth) outset;
        background: var(--chrome-hsl);
        padding: 3px 6px 4px 6px;
        pointer-events: none;
        color: #999999;
        line-height: 100%;
        text-shadow: 0 1px rgba(255, 255, 255, 0.75);
    }

    button.enabled {
        pointer-events: auto;
        color: black;
        text-shadow: none;
    }

    button.pressed,
    button.enabled:active {
        filter: brightness(0.75);
        border-top: var(--border-color-dark) var(--chrome-depth) inset;
        border-right: var(--border-color-light) var(--chrome-depth) inset;
        border-bottom: var(--border-color-light) var(--chrome-depth) inset;
        border-left: var(--border-color-dark) var(--chrome-depth) inset;
    }
</style>
